export function getVodBuildFlag() {
	const { REACT_APP_VOD_BUILD } = process.env;

	return !(REACT_APP_VOD_BUILD === 'false');
}
